import type { ButtonHTMLAttributes } from "react";
import { classNames } from "../../support/formatters/class-formatter";

import styles from "./bullet-pagination.module.css";

export interface BulletPaginationProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  isActive?: boolean;
}

export function BulletPagination({
  isActive,
  className,
  ...props
}: Readonly<BulletPaginationProps>) {
  return (
    <button
      type="button"
      {...props}
      className={classNames(
        styles.PaginationBullet,
        isActive && styles.PaginationBulletActive,
        className
      )}
    />
  );
}
